<template>
  <div class="slider__card">
    <img src="~@/assets/images/slider-item-imgs/ico224.svg" alt="ico224.svg">
    <div class="text-container">
      <text-string label-id="txt1436"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "storage-instruction-one"
  }
</script>